// Light palette shared by the Home launcher and the app-level assistant panel.
export const HOME_CHAT_THEME = {
  pageBg: "#F6F7F9",
  cardBg: "#FFFFFF",
  cardBorder: "#E4E8EE",
  divider: "#EEF1F5",
  sectionTitle: "#111827",
  muted: "#6B7280",
  link: "#1D4ED8",
  chip: "#1D4ED8",
  collapsedPillBg: "#FFFFFF",
  collapsedPillBorder: "#D5DCE5",
  collapsedPillShadow: "none",
};
